import { memo } from 'react';

import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import Text from '@wconcept/wconcept-ui-renewal/components/atoms/Text';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';

import * as S from './style';

interface IProps {
  rank?: string | number;
  text?: string;
  isNew?: boolean;
  onClick?: () => void;
}

const TextRankItem = ({ rank, text = '', isNew = false, onClick }: IProps) => {
  const className = classNameBind(['rank-text-item item']);

  return (
    <S.TextRankItem className={className}>
      <Button onClick={onClick}>
        <Text className="text-box">
          {rank && <S.Rank className="num">{rank}</S.Rank>}
          <Text size={14} className="word" ellipsis={1}>
            {text}
          </Text>
        </Text>
        {isNew && <S.New className="new">NEW</S.New>}
      </Button>
    </S.TextRankItem>
  );
};

export default memo(TextRankItem);
